/* Auzi | Edits only. Curated presentation variants from active catalogue media associations.
   Changes are in this unpublished theme only. Shopify product data and Live theme are untouched.
   Respect explicit visitor ?variant selections, disabled options, and later manual changes. */
(function(){
  const preferred={"auzi-x":["White","Gold vermeil","Left"],"auzi-constellation":["Left","White","Gold vermeil"],"a-star-is-born":["Left","White","Gold vermeil"],"lunar-gaze":["Left","Gold vermeil"],"rock-on-1":["Case Only","Gold vermeil","Black"],"glimora":["Gold vermeil","Left"],"cochlear-signature":["Left","Gold vermeil","White"],"beauty-in-the-cracks":["Left","Gold vermeil"],"skeletons-out-of-the-closet":["Left","Gold vermeil"],"cochlear-elevate":["Left","Gold vermeil","White"],"cochlear-everiday":["Left","Gold vermeil"],"sirene-rose":["Left","Gold vermeil"],"ombre-night-sky":["Left","Gold vermeil"],"birthstone-aura":["Left","Gold vermeil","Jan (Garnet)"],"cupid":["Gold vermeil","Left"],"ears-lightning":["Left","Gold vermeil"],"dreamy-kanso-2-3":["One","Gold vermeil","White"],"hearloom-relic":["Individual","Gold vermeil"],"tide-jewel":["Gold vermeil","Left"],"tide-jewel-copy":["Gold vermeil","Left"],"afterglow":["Left","Gold vermeil"],"wild-moon":["Left","Gold vermeil"],"shine-bright":["Left","Gold vermeil"]};
  const applied = new WeakSet();
  function apply(){
    if (new URLSearchParams(location.search).has('variant') ||
        new URLSearchParams(location.search).has('option_values')) return;
    document.querySelectorAll('product-info').forEach(info => {
      if(applied.has(info))return;
      const url=info.dataset.url||'';
      const handle=url.split('/products/')[1]?.split(/[?#/]/)[0];
      const desired=preferred[handle];
      if(!desired)return;
      const picker=info.querySelector('variant-selects');
      if(!picker)return;
      const positions=Array.from(picker.querySelectorAll('.product-form__input[data-option-position]'))
         .sort((a,b)=>Number(a.dataset.optionPosition)-Number(b.dataset.optionPosition));
      const selects=positions.map(p=>p.querySelector('select'));
      if(selects.length!==desired.length||selects.some(x=>!x))return;
      const changes=[];
      for(let i=0;i<selects.length;i++){
         const select=selects[i];
         const option=Array.from(select.options).find(o=>o.value===desired[i]);
         if(!option || option.disabled || select.disabled)return;
         if(select.value!==desired[i])changes.push({select,desired:desired[i]});
      }
      applied.add(info);
      if(changes.length!==1)return; /* Limit to a single atomic variant choice. */
      const change=changes[0];
      change.select.value=change.desired;
      change.select.dispatchEvent(new Event('change',{bubbles:true}));
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',apply,{once:true});
  else apply();
  document.addEventListener('shopify:section:load',apply);
})();
